import { styled, useTheme } from "styled-components";

import { FakeLink } from "components/lib/UI";

type SidebarContainerProps = {
  $top?: number;
  $bottom?: number;
} & React.HTMLAttributes<HTMLDivElement>;

const SidebarContainer = styled.div<SidebarContainerProps>`
  @media (min-width: 1400px) {
    flex: 0.25 1 20%;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-right: 1px solid #babcbe;
  padding: 25px;
  position: -webkit-sticky;
  position: sticky;
  ${({ $top, $bottom }) => ($top || !$bottom ? `top: ${$top || 0}px;` : "")}
  ${({ $bottom }) => ($bottom ? `bottom: ${$bottom}px;` : "")}
  min-height: 100vh;
`;
type HomeSidebarProps = { children: React.ReactNode } & SidebarContainerProps;
const HomeSidebar = ({ children, ...props }: HomeSidebarProps) => (
  <SidebarContainer {...props}>{children}</SidebarContainer>
);

const ContentColumnContainer = styled.div`
  flex: 0.2 1 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => (theme.sizes.isMobile ? "" : "25px;")};
`;

type HomeContentColumnProps = {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;
const HomeContentColumn = ({ children, ...props }: HomeContentColumnProps) => {
  const theme = useTheme();
  return (
    <ContentColumnContainer {...props} theme={theme}>
      {children}
    </ContentColumnContainer>
  );
};

const ViewMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

type ViewMoreProps = { onClick: () => void; children: React.ReactNode };
const ViewMore = ({ onClick, children }: ViewMoreProps) => (
  <ViewMoreContainer>
    <FakeLink onClick={onClick} withBorder>
      {children}
    </FakeLink>
  </ViewMoreContainer>
);

export { HomeSidebar, HomeContentColumn, ViewMore };
